module.exports = __webpack_public_path__ + "img/harmony-logo.d8338d7f.png";